module.exports = __webpack_public_path__ + "static/media/05.bf5c2285.jpg";